import React from 'react';
import { bool, string, node } from 'prop-types';

import ContentBlock from '../ContentBlock';
import AuthorBlock from '../AuthorBlock';

import styles from './ArticlePostContent.scss';

function ArticlePostContent({
  title,
  mediaUrl,
  mediaAltText,
  publishDate,
  description,
  breadcrumb,
  authorName,
  isInapp,
}) {
  const descr = description;

  return (
    <article className={styles.root}>
      <header className={styles.header}>
        {!isInapp && breadcrumb}
        <h1 className={styles.title}>{title}</h1>
        <AuthorBlock authorName={authorName} publishDate={publishDate} />
        <img src={mediaUrl} className={styles.image} alt={mediaAltText} />
      </header>
      <ContentBlock
        description={descr}
        publishDate={publishDate}
        authorName={authorName}
      />
    </article>
  );
}

ArticlePostContent.propTypes = {
  authorName: string.isRequired,
  breadcrumb: node.isRequired,
  description: string.isRequired,
  isInapp: bool.isRequired,
  mediaAltText: string.isRequired,
  mediaUrl: string.isRequired,
  publishDate: string.isRequired,
  title: string.isRequired,
  type: string.isRequired,
};

export default ArticlePostContent;



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ArticlePostContent/ArticlePostContent.jsx